<template>
  <div
    id="navTitle"
    class="navTitle"
    :style="'background:' + color + ';color:' + font"
  >
    <Button
      v-if="isback"
      icon="back"
      :style="'color:' + font"
      slot="left"
      @click.native="goback()"
    ></Button>
    <div class="ntitle">{{ title }}</div>
    <div class="rightIcon" v-if="ask" @click="goHelp">
      <svg
        t="1583284262681"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="2776"
        width="128"
        height="128"
      >
        <path
          d="M512 936.740571A424.740571 424.740571 0 1 0 512 87.259429a424.740571 424.740571 0 0 0 0 849.481142z m0 64A488.740571 488.740571 0 1 1 512 23.186286a488.740571 488.740571 0 0 1 0 977.554285zM422.765714 436.297143v0.658286a32.036571 32.036571 0 1 1-64-2.706286c0-47.250286 13.312-86.162286 39.570286-116.882286 28.818286-33.060571 68.461714-49.298286 118.710857-49.298286 44.763429 0 80.969143 12.946286 108.544 39.131429 26.477714 24.868571 39.643429 58.587429 39.643429 100.352 0 30.281143-9.435429 58.148571-27.794286 82.358857-7.606857 9.728-24.137143 25.819429-54.125714 52.955429a151.844571 151.844571 0 0 0-31.232 35.328c-8.411429 14.482286-12.434286 29.257143-12.434286 45.129143l1.097143 19.382857a11.190857 11.190857 0 0 1-11.190857 11.849143h-41.837715a11.190857 11.190857 0 0 1-11.264-11.190858v-19.382857c0-21.211429 4.388571-40.96 13.165715-58.148571 10.459429-22.528 32.182857-48.566857 63.634285-76.068572 19.602286-19.602286 25.746286-25.892571 29.769143-30.939428 12.8-16.530286 19.017143-32.841143 19.017143-49.956572 0-25.453714-7.314286-45.568-21.357714-60.196571-14.774857-14.774857-36.352-22.162286-65.609143-22.162286-32.621714 0-56.027429 10.532571-72.118857 31.890286-13.531429 16.969143-19.968 41.691429-19.968 75.849143 0 0.731429 0 1.389714-0.146286 2.048zM512 763.611429a31.963429 31.963429 0 1 1 0-64 31.963429 31.963429 0 0 1 0 63.926857z"
          p-id="2777"
          fill="#bfbfbf"
        ></path>
      </svg>
    </div>
    <!-- <span  @click.native="goback()" class="icon icon-xiangzuo"></span> -->
  </div>
</template>
<script>
import { Button } from "mint-ui";
import "mint-ui/lib/style.css";
export default {
  name: "navTitle",
  props: {
    title: String,
    path: {
      //如果没有传递目标页面则默认返回上一级页面
      type: String,
      default: ""
    },
    isback: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: "#fff"
    },
    font: {
      type: String,
      default: "#333"
    },
    ask: Boolean,
    askName:String,
  },
  components: {
    Button
  },
  data: function() {
    return {};
  },
  methods: {
    goback() {
      if (this.path) {
        this.$router.push({ path: this.path });
        return;
      }
      // console.log('this.$router.',this.$router)
      // console.log('this.$router.',this.$router.app._route.path)
      this.$router.go(-1);
    },
    goHelp() {
      switch (this.askName) {
        case 'JuanCash':this.$router.push({ path: "/user/cashHelp",query:{id:8}});break;
        case 'GCash':this.$router.push({ path: "/user/cashHelp",query:{id:7}});break;
        case 'game':
          this.$dialog.confirm({
            mes: "Check the results on the lottery website?",
            title: "Hot-Spot",
            opts: [
              {
                txt: "Cancel",
                color: false,
                callback: () => {
                  return
                }
              },
              {
                txt: "To travel to",
                color: "#00C3F9",
                callback: () => {
                  location.href="https://www.calottery.com/draw-games/hot-spot#section-content-1-5"
                }
              }
            ]
          });
         ;break;
      }
    }
  }
};
</script>
<style scoped>
.navTitle {
  width: 7.5rem;
  left: 0;
  right: 0;
  top:0px;
  margin: 0 auto;
  height: 1rem;
  position: fixed;
  display: flex;
  z-index: 9999;
 
}
.navTitle button {
  width: 0.6rem;
  height: 1rem;
  text-align: center;
  line-height: 1rem;
  background: none;
  box-shadow: none;
  color: #333;
  padding: 0px;
  position: absolute;
  left: 0.1rem;
  top: 0px;
}
.navTitle button::after {
  border: none;
  background: none;
}

.navTitle .ntitle {
  width: 100%;
  line-height: 1rem;
  text-align: center;
  padding: 0 0.3rem;
  box-sizing: border-box;
}
.rightIcon {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 50px;
  line-height: 1rem;
  text-align: center;
}
.rightIcon svg {
  font-size: 21px;
}
</style>
